import React, {useEffect, useState} from 'react';
import {IconContainer, Input, Modal, Spinner} from "@tag/tag-components-react-v4";
import {CustomerDTO} from "../types/CustomerDTO";
import AppRolesService from "../../General/services/AppRolesService";
import {useIsAuthenticated, useMsal} from "@azure/msal-react";
import CustomerService from "../services/CustomerService";
import {WarningFilled} from "@tag/tag-icons";
import { ProjectAccents } from "../../General/config/projectAccents";


function LockConfirmationModal(props: { visible: boolean, selectedCustomer: CustomerDTO, handleClose: Function, handleLock: Function }) {
    
    const { accounts } = useMsal();
    const isAuthenticated = useIsAuthenticated();
    const [salesForceId, setSalesForceId] = useState('');
    const [loading, setLoading] = useState<boolean>();
    const [lastSignInDate, setLastSignInDate] = useState<Date|null>();
    
    useEffect(() => {
        setLoading(true)
        CustomerService.getLastSignInDateTime(props.selectedCustomer.clientId, props.selectedCustomer.environmentName)
            .then((e) => {
                setLastSignInDate(e);
                setLoading(false);
            });
    }, [props.selectedCustomer.clientId, props.selectedCustomer.environmentName]);

    const isWithinAWeek = (date: Date) => {
        const oneWeekAgo = new Date();
        oneWeekAgo.setDate(oneWeekAgo.getDate() - 7);
        return new Date(date) >= oneWeekAgo;
    };

    const renderModalContent = () => (
        <>
            <p>Are you sure you wish to lock {props.selectedCustomer.name}?</p>

            {loading && <Spinner />}

            {lastSignInDate && isWithinAWeek(lastSignInDate) && (
                <div style={{ display: "flex", alignItems: "center", gap: "8px", marginTop: "8px" }}>
                    <IconContainer accent={ProjectAccents.PeoplePlanner}>
                        <WarningFilled />
                    </IconContainer>
                    <span>Warning: A user has logged into this environment within the last week.</span>
                </div>
            )}

            <p>This environment will be deleted in two weeks.</p>

            <Input
                placeholder="Enter Salesforce ID to confirm"
                clearButton
                style={{ width: "200px" }}
                onChange={(e) => setSalesForceId(e.currentTarget.value)}
            />
        </>
    );

    let content;
    content = <>
        <Modal
            visible={props.visible}
            accent={ProjectAccents.PeoplePlanner}
            heading={'Confirm'}
            onCancelButtonClick={() => {
                props.handleClose();
            }}
            onClose={() => props.handleClose()}
            primaryButtonProps={{text: 'Confirm', disabled: !salesForceId}}
            onPrimaryButtonClick={() => props.handleLock(salesForceId)}
        >
            <div>
                {renderModalContent()}
            </div>
        </Modal>
    </>

    return (
        <>
            {content}
        </>
    )

}

export default LockConfirmationModal;
